import {Base} from './Base';
import events from '../../constants/events';
import {dispatchEvent} from '../../utilities/customEvents';
import {ajaxUpdate} from '../../utilities/ajax';

const APP_ID = '928494194345058';
const CLIENT_KEY = '42dfda34b4ebe008e9e8445730c7ec31';
const igAccessToken = `${APP_ID}|${CLIENT_KEY}`;

export class InstagramGallery extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);

    this.instagramGalleryUniverse = element.dataset.universe;
    this.init();
  }

  init() {
    this.getInstagramData();
    this.populateHeadline();
    this.populateCarousel();
  }


  getInstagramData() {    
    const instagramDataElement = document.getElementById(`instagram-${this.instagramGalleryUniverse}-data`);
    if (instagramDataElement) {
      try {
        this.instagramDataElement = JSON.parse(instagramDataElement.innerHTML);
      } catch (e) {
        // Error in the JSON
      }
    }
  }

  generateHeadlineMarkup() {
    if (this.instagramDataElement['gallery_title']) {
      return this.instagramDataElement['title_link'] ? `
        <a href="${this.instagramDataElement['title_link']}" target="_blank" class="text-decoration-none">
          <h2 class="heading-5">
          ${this.instagramDataElement['gallery_title']}
          </h2>
        </a>` : `
        <h2 class="heading-5">
          ${this.instagramDataElement['gallery_title']}
        </h2>
      `;
    }
  }

  // women: https://instafeed.nfcube.com/feed/v4?charge=22136324144&fu=0&limit=6&account=mosmosh.myshopify.com&fid=0&hash=9f9e5201156420c70cf8572a20c074f1
  // men: https://instafeed.nfcube.com/feed/v4?charge=1&fu=0&limit=6&account=mosmosh.myshopify.com&fid=15291&hash=$2y$10$uxmMLkXcJybCqYSi2MRGZOIq4L777UgHDdNDXSyL8BTmLqNpyCbd

  //<span class="heading-4 instagram-gallery__item-title">${imageDefinition.caption.text}</span>
  
  generateCarouselMarkup() {
    return fetch(this.instagramDataElement.fetch_url)
      .then(res => res.json())
      .then(( {data} ) => {
        return data.map((imageDefinition) => {
          return (`
          <div class="swiper-slide carousel__item carousel__item--4-of-8 carousel__item--2-of-12-md">
            <div class="instagram-gallery__item">
              <a href="${imageDefinition.link}" target="_blank" class="instagram-gallery__link">
                <div class="instagram-gallery__image">
                  <div class="media media--square">

                    <div class="media__image">
                      <img
                        class="media__source lazy"
                        data-src="${imageDefinition.images.standard_resolution.url}"
                        data-sizes="(max-width: 1023px) 50vw, 16.666vw"
                        alt="${imageDefinition.caption.text}"
                        data-object-fit
                      />
                    </div>
                  </div>
                </div>

            </a>
          </div>
        </div>`);
          }).join('');
      });
  }

  populateHeadline() {
    const { headingWrapper } = this.refs;
    headingWrapper.innerHTML = this.generateHeadlineMarkup();
  }

  populateCarousel() {
    const { carouselWrapper } = this.refs;
    this.generateCarouselMarkup()
      .then(html => carouselWrapper.innerHTML = html)
      .then(() => {
        dispatchEvent(window, events.PRODUCT_IMAGES_UPDATED);
      });
  }
}
